import React, { useEffect, useRef, useState } from "react";
import css from "./AiChatBot.module.css";
import { communityPostAccess, PRIMARY_GPT_NAME, PRIMARY_RULEBOOK_GROUP_ID } from "../../util/types";
import { FormattedMessage } from "react-intl";
import ChatBotSideBar from "../../containers/AiChatBotPage/ChatBotSideBar/ChatBotSideBar";
import IconCollection from "../IconCollection/IconCollection";
import Button from "../Button/Button";
import classNames from "classnames";
import { capitalizeWords, currentUserRole, getUserPermissions } from "../../util/data";
import SideBar from "./FeedTabs/SideBar/SideBar";
import GoBackButton from "../GoBackButton/GoBackButton";

import {
  EXPLORE,
  NOTIFICATION,
} from '../../util/types';
import NotificationMobileModal from "../NotificationDropdown/NotificationMobileModal";
import CreatePostBar from "../../containers/CircleCommunityPage/components/CreatePostBar/CreatePostBar";
import { createResourceLocatorString } from "../../util/routes";
import { useHistory } from "react-router-dom";
import { useRouteConfiguration } from "../../context/routeConfigurationContext";
import { v4 as uuidv4 } from 'uuid';
import { openIntecomOnClickEvents } from "../IntercomComponent/IntercomComponent";
import MobileBottomTabs from "../../containers/CircleCommunityPage/components/MobileBottomTabs/MobileBottomTabs";
import ModalInMobile from "../ModalInMobile/ModalInMobile";

const AiChatBot = (props) => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const {
    fetchChatInProgress,
    chatDetails,
    fetchChatError,
    gptsDetails = [],
    currentUser,
    onUserChatWithGpt,
    userChatInProgress,
    userChatError,
    params,
    userFavChatDetails,
    scrollToSection,
    onToggleCreatePost,
    onFetchNotifications,
    requestNotificationsInProgress,
    notificationsData,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onMarkNotificationRead,
    onManageDisableScrolling,
    onGetNotificationPreference,
    onUpdateNotificationPreference,
    onMarkAllNotificationsAsRead,
    isCreatePost,
    requestDirectUpload,
    currentCommunityMember,
    spaceListData,
    advancedSearchData,
    onSubscriptionPermissionRequest,
    onAdvancedSearch,
    userChatDetails,
    onAddOrRemoveFavChats,
    historyChatDetails
  } = props;

  const chatBoxRef = useRef(null);
  const [isSmallHeight, setIsSmallHeight] = useState(false);
  const [showMobileWarning, setShowMobileWarning] = useState(false);


  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { rulebookId, sessionId } = params || {};
  const previousChatRouteRef = useRef({ rulebookId, sessionId });

  const userSubscriptionRole = currentUserRole(currentUser);

  const checkCreatePostAuth = getUserPermissions(userSubscriptionRole, communityPostAccess);

  const { favGpt = [], gpts = [] } = userFavChatDetails || {};
  const favFileIds = favGpt?.map((chat) => chat.rulebook_id) || [];

  useEffect(() => {
    const previousRoute = previousChatRouteRef.current;
    const previousRulebookId = previousRoute.rulebookId || PRIMARY_RULEBOOK_GROUP_ID;
    const nextRulebookId = rulebookId || PRIMARY_RULEBOOK_GROUP_ID;
    const isGeneratedSessionNavigation =
      !previousRoute.sessionId &&
      !!sessionId &&
      previousRulebookId === nextRulebookId;

    if (!isGeneratedSessionNavigation) {
      setMessages([]);
    }
    previousChatRouteRef.current = { rulebookId, sessionId };
  }, [rulebookId, sessionId]);
  useEffect(() => {
    const checkHeight = () => {
      setIsSmallHeight(window.innerHeight < 700);
    };

    checkHeight(); // run on mount
    window.addEventListener('resize', checkHeight); // update on resize

    return () => window.removeEventListener('resize', checkHeight); // cleanup
  }, []);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  // Check session storage to see if modal was already shown to user
  const getIsAIModalShown = () => {
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem('isAIModalforMobileshowed') === 'true';
    }
    return false;
  };

  const setAIModalShown = () => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('isAIModalforMobileshowed', 'true');
    }
  };

  const handleIconClick = content => {
    const { tab, pageName, params } = content;

    if (tab === 'MENU') {
      setIsSideBarOpen(tab);
    }
    else if (tab === 'ADD_MENU') {
      if (!checkCreatePostAuth) {
        onSubscriptionPermissionRequest(true);
        return;
      }
      onToggleCreatePost(true);
    }

    else if (tab == "SUPPORT") {
      openIntecomOnClickEvents();
      return;
    }
    else {
      return pageName && history.push(createResourceLocatorString(pageName, routeConfiguration, params, {}))
    }

    // else if (tab === EXPLORE) {
    //   window.location.href = '/feed-page/group-search';
    // } else if (tab === NOTIFICATION) {
    //   setIsOpen(true);
    // }
  };

  const closeSideBar = () => {
    setIsSideBarOpen(false);
  };


  const selectedRulebook = gptsDetails?.find((e) => e.rulebook_id == rulebookId) || {};
  const { group_id, rulebook_id, rulebook_name, logo_url } = selectedRulebook || {};
  const selectedChat = chatDetails?.filter(e => e.session_id == sessionId).sort((a, b) => new Date(a.created_at || "") - new Date(b.created_at || "")) || [];
  const isPrimaryRulebook = !rulebookId || rulebookId === PRIMARY_RULEBOOK_GROUP_ID;
  const hasSelectedRulebook = isPrimaryRulebook || !!rulebook_id;
  const effectiveRulebookId = isPrimaryRulebook ? 'general' : rulebook_id;
  const effectiveGroupId = isPrimaryRulebook ? PRIMARY_RULEBOOK_GROUP_ID : group_id;

  // Check is this a new chat
  const isMessageLength = (Array.isArray(selectedChat) && selectedChat.length) || (Array.isArray(messages) && messages.length);

  // Show mobile warning modal on mount if it's a new chat, mobile device, and not shown before
  useEffect(() => {
    if (isMobile && !isMessageLength && !getIsAIModalShown()) {
      setShowMobileWarning(true);
    }
  }, [isMobile, isMessageLength]);

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages, userChatInProgress]); // Scroll when these values change


  const sendMessage = async (input) => {
    if (!input.trim()) return;
    if (!hasSelectedRulebook || !effectiveRulebookId || !effectiveGroupId) {
      setMessages((prev) => [...prev, {
        text: "Rulebook is still loading or no longer available. Please choose a rulebook and try again.",
        sender: "bot"
      }]);
      return;
    }

    const nextSessionId = sessionId || uuidv4();
    if (!sessionId) {
      history.replace(createResourceLocatorString(
        'AiChatBotRulebookPage',
        routeConfiguration,
        { rulebookId: rulebookId || PRIMARY_RULEBOOK_GROUP_ID, sessionId: nextSessionId },
        {}
      ));
    }

    const userMessage = { text: input, sender: "user" };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");

    onUserChatWithGpt({
      rulebook_id: effectiveRulebookId,
      user_id: currentUser?.id?.uuid,
      query: input,
      group_id: effectiveGroupId,
      session_id: nextSessionId
    })
      .then((response) => {
        const responseText = response?.response || response;
        if (responseText) {
          setMessages((prev) => [...prev, { text: responseText, sender: "bot" }]);
        }
      })
      .catch((error) => {
        setMessages((prev) => [...prev, { text: "Error fetching response. Try again.", sender: "bot" }]);
      });
  };

  const formatMessage = (message) => {
    if (typeof message !== "string") return message;

    // ✅ Split text into lines & map each one
    return message.split("\n").map((line, index) => {
      // ✅ Convert bullet points & numbered lists into `<li>` elements
      if (line.match(/^\d+\./) || line.match(/^[-*•]/)) {
        return <li key={index}>{line.replace(/^[-*•]\s*/, "").trim()}</li>;
      }

      // ✅ Convert headings (if they end with `:` or start with `#`)
      if (line.trim().endsWith(":") || line.startsWith("#")) {
        return <strong key={index} className={css.heading}>{line.trim()}</strong>;
      }

      // ✅ Otherwise, treat it as a normal paragraph
      return <p key={index} className={css.paragraph}>{line.trim()}</p>;
    });
  };

  const rulebookName = capitalizeWords(rulebook_name) || PRIMARY_GPT_NAME;

  const mobileBottomTabsComponent = <MobileBottomTabs handleIconClick={handleIconClick} currentUser={currentUser} isMobile={isMobile} selectedTab={"TURNOUTAI"} />;

  const NotificationMobileComponent = (
    <NotificationMobileModal
      onFetchNotifications={onFetchNotifications}
      requestNotificationsInProgress={requestNotificationsInProgress}
      notificationsData={notificationsData}
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(false)}
      onMarkNotificationRead={onMarkNotificationRead}
      onManageDisableScrolling={onManageDisableScrolling}
      requestNotificationPreferenceInProgress={requestNotificationPreferenceInProgress}
      notificaitonPreferenceData={notificaitonPreferenceData}
      onGetNotificationPreference={onGetNotificationPreference}
      onUpdateNotificationPreference={onUpdateNotificationPreference}
      onMarkAllNotificationsAsRead={onMarkAllNotificationsAsRead}
      currentUser={currentUser}
    />
  );

  const handlePostCreation = async (apiParams, spaceId, postId) => {
    const response = await onCreateSpacePost(apiParams, spaceId, postId)
    if (response?.id) {
      return history.push(
        createResourceLocatorString(
          'PostViewPage',
          routeConfiguration,
          { spaceId, slug: response?.slug, postId: response?.id },
        )
      );
    }
  };

  return (
    <div className={css.container}>
      {/* Sidebar */}
      <div className={classNames(css.sidebar, isSideBarOpen && css.sidebarOpen)}>
        <ChatBotSideBar
          currentPage={'AiChatBotPage'}
          gptsDetails={historyChatDetails}
          fetchChatInProgress={fetchChatInProgress}
          chatDetails={historyChatDetails}
          fetchChatError={fetchChatError}
          isSideBarOpen={isSideBarOpen}
          userFavChatDetails={userFavChatDetails}
          scrollToSection={scrollToSection}
          params={params}
          userChatDetails={userChatDetails}
          currentUser={currentUser}
        />
      </div>
      {/* Chat Section */}
      <div className={css.mobileChatSection}>
        <div className={css.goBackBtnStyle}>
          <GoBackButton />
        </div>
        <div className={css.chatSection}>
          {/* {sessionId && <GoBackButton desktopOnly />} */}
          {isMobile ? null : (
            <div className={css.chatBannerSection}>
              <b>
                <FormattedMessage id="AiChatBotPage.bannerHeadingBold" />{' '}
              </b>
              <FormattedMessage id="AiChatBotPage.bannerHeadingText" />
            </div>
          )}

          <div className={css.chatSectionHeader}>
            {!isMessageLength ? (
              <div className={isMobile ? css.headerWrapperMobile : css.headerWrapper}>
                <div className={css.leftLogo}>
                  {logo_url ? (
                    <img src={logo_url} alt="image not found" width="126px" height="126px" />
                  ) : (
                    <IconCollection name="thqAI" />
                  )}
                  <h2 className={css.title}>{rulebookName}</h2>
                </div>
                {rulebook_id ? (
                  <div
                    className={css.favouriteButton}
                    onClick={() => {
                      typeof onAddOrRemoveFavChats == 'function' &&
                        currentUser?.id?.uuid &&
                        onAddOrRemoveFavChats({
                          rulebook_id: rulebook_id,
                          user_id: currentUser?.id?.uuid,
                        });
                    }}
                  >
                    {favFileIds.includes(rulebook_id) ? (
                      <IconCollection name="myFavouriteIconFill" />
                    ) : (
                      <IconCollection name="myFavouriteIconFillBorder" />
                    )}
                  </div>
                ) : null}
              </div>
            ) : (
              <div className={css.topHeadingWrapper}>
                <div className={css.headingText}>
                  {logo_url ? (
                    <img src={logo_url} alt="image not found" width="126px" height="126px" />
                  ) : (
                    <IconCollection name="thqAI" />
                  )}
                  <h2 className={css.title}>{rulebookName}</h2>
                </div>
                {rulebook_id ? (
                  <div
                    className={css.favouriteButtonAfter}
                    onClick={() => {
                      typeof onAddOrRemoveFavChats == 'function' &&
                        currentUser?.id?.uuid &&
                        onAddOrRemoveFavChats({
                          rulebook_id: rulebook_id,
                          user_id: currentUser?.id?.uuid,
                        });
                    }}
                  >
                    {favFileIds.includes(rulebook_id) ? (
                      <IconCollection name="myFavouriteIconFill" />
                    ) : (
                      <IconCollection name="myFavouriteIconFillBorder" />
                    )}
                  </div>
                ) : null}
              </div>
            )}
            {/* <p className={css.description}>
            <FormattedMessage id="AiChatBotPage.heading" values={{ rulebook_name: rulebookName }} />
          </p> */}

            {/* Suggested Questions dummy will update later */}
            {/* <div className={css.suggestions}>
            <Button onClick={() => {
              sendMessage('What are the registration requirements for horses?')
            }}><FormattedMessage id="AiChatBotPage.text1" /></Button>
            <Button onClick={() => {
              sendMessage('How do I apply for registration in horses community?')
            }}><FormattedMessage id="AiChatBotPage.text2" /></Button>
            <Button onClick={() => {
              sendMessage('What penalties exist in horses rulebook ?')
            }} ><FormattedMessage id="AiChatBotPage.text3" /></Button>
            <Button onClick={() => {
              sendMessage('What are the types of horses ?')
            }} ><FormattedMessage id="AiChatBotPage.text4" /></Button>
          </div> */}
            {userChatError ? <FormattedMessage id="AiChatBotPage.errorText" /> : null}
            {/* Chat Box */}

            {messages.length > 0 ||
              userChatInProgress ||
              (selectedChat && selectedChat.length > 0) ? (
              <div
                className={`${css.chatBox} ${isSmallHeight ? css.smallHeightChatBox : ''}`}
                ref={chatBoxRef}
              >
                {selectedChat && selectedChat.length > 0
                  ? selectedChat.map((chat, index) => {
                    return (
                      <React.Fragment key={chat.id || `${chat.session_id}-${index}`}>
                        <span className={css.userMessage}>{formatMessage(chat.query)} </span>
                        <span className={css.botMessage}>{formatMessage(chat.response)}</span>
                      </React.Fragment>
                    );
                  })
                  : null}

                {messages?.map((msg, index) => (
                  <div
                    key={index}
                    className={msg.sender === 'user' ? css.userMessage : css.botMessage}
                  >
                    {formatMessage(msg.text)}
                  </div>
                ))}
                {userChatInProgress ? (
                  <div className={css.loading}>
                    <FormattedMessage id="AiChatBotPage.thinking" />
                  </div>
                ) : null}
              </div>
            ) : !isMobile && !isMessageLength ? (
              <div className={css.nochatTitle}>
                <FormattedMessage id="AiChatBot.nochatTitle" values={{ rulebookName }} />
              </div>
            ) : null}

            {/* Chat Input */}
            <div className={!isMessageLength ? css.nochatInputContainer : css.inputContainer}>
              <textarea
                type="textarea"
                value={input}
                onChange={e => setInput(e.target.value)}
                className={css.chatInput}
                placeholder={`Message`}
              />
              <Button className={css.plusButton}>{/* <IconCollection name="iconAdd" /> */}</Button>
              <Button
                onClick={() => sendMessage(input)}
                className={css.sendButton}
                disabled={userChatInProgress}
              >
                <IconCollection name="send_message" />
                Send message
              </Button>
            </div>
            {!isMessageLength && isMobile ? (
              <div className={css.bottomInfo}>
                <FormattedMessage id="AiChatBot.bottomInfo" />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {currentUser && currentUser?.id ? mobileBottomTabsComponent : null}
      <SideBar
        isOpen={isSideBarOpen}
        onClose={closeSideBar}
        currentPage={'AiChatBotPage'}
        gptsDetails={gptsDetails}
        fetchChatInProgress={fetchChatInProgress}
        chatDetails={chatDetails}
        fetchChatError={fetchChatError}
        isSideBarOpen={isSideBarOpen}
        userFavChatDetails={userFavChatDetails}
        scrollToSection={scrollToSection}
        currentUser={currentUser}
      />
      {NotificationMobileComponent}

      {isCreatePost ? (
        <div>
          <CreatePostBar
            requestDirectUpload={requestDirectUpload}
            currentCommunityMember={currentCommunityMember}
            spaceListData={spaceListData}
            onCreateSpacePost={handlePostCreation}
            isCreatePost={isCreatePost}
            onToggleCreatePost={value => {
              checkCreatePostAuth
                ? onToggleCreatePost(value)
                : onSubscriptionPermissionRequest(true);
            }}
            onAdvancedSearch={onAdvancedSearch}
            advancedSearchData={advancedSearchData}
            params={params}
            currentUser={currentUser}
          />
        </div>
      ) : null}

      {/* Mobile Warning Modal */}
      {isMobile && showMobileWarning ? (
        <ModalInMobile
          id="AiChatBotWarningModal"
          isModalOpenOnMobile={showMobileWarning && !isMessageLength && isMobile}
          onClose={() => setShowMobileWarning(false)}
          showAsModalMaxWidth={768}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <div className={css.warningModalContent}>
            <div className={css.modalHeader}>
              <FormattedMessage
                id="AiChatBot.mobileWarning.header"
                defaultMessage="About Turnout AI Rulebooks"
              />
            </div>
            <div className={css.modalBody}>
              <FormattedMessage
                id="AiChatBot.mobileWarning.message"
                defaultMessage="The Turnout AI Rulebooks feature is currently in beta testing. Please check your rulebook for official answers. To help us improve the experience, we would be grateful if you report any issues to support by using the orange THQ circle. We appreciate your patience and your help as we bring this new technology onboard for the horse community."
              />
            </div>
            <button className={css.modalContinueButton} onClick={() => {
              setAIModalShown();
              setShowMobileWarning(false);
            }}>
              <FormattedMessage id="AiChatBot.mobileWarning.continue" defaultMessage="Continue" />
            </button>
          </div>
        </ModalInMobile>
      ) : null}
    </div>
  );
};

export default AiChatBot;
